import {
  Code,
  Database,
  Cloud,
  GitBranch,
  Zap,
  Bug,
  Server,
  Network,
  Shield,
  Gauge,
  TrendingUp,
  Activity,
  Wrench,
  Accessibility,
  Globe,
  Languages,
  CircleUser,
} from 'lucide-react';

export const PROBLEM_ICON_OPTIONS = [
  'Bug',
  'Code',
  'Database',
  'Cloud',
  'GitBranch',
  'Zap',
  'Server',
  'Network',
  'Shield',
  'Gauge',
  'TrendingUp',
  'Activity',
  'Wrench',
  'Accessibility',
  'Globe',
  'Languages',
  'CircleUser',
];

const iconComponents = {
  Code,
  Database,
  Cloud,
  GitBranch,
  Zap,
  Bug,
  Server,
  Network,
  Shield,
  Gauge,
  TrendingUp,
  Activity,
  Wrench,
  Accessibility,
  Globe,
  Languages,
  CircleUser,
  Security: Shield,
  Performance: Gauge,
  Scalability: TrendingUp,
  Reliability: Activity,
  Maintainability: Wrench,
  Usability: CircleUser,
  Internationalization: Globe,
  Localization: Languages,
};

export const getProblemIcon = (iconName) => iconComponents[iconName] || Zap;
